import PrazosDeVencimento from "@/views/administracao/PrazosDeVencimento.vue";
import EditarPrazoDeVencimento from "@/views/administracao/EditarPrazoDeVencimento.vue";

import EnviosSemMovimento from "@/views/administracao/EnviosSemMovimento.vue";
import EditarEnviosSM from "@/views/administracao/EditarEnviosSM.vue";

import Prorrogacoes from "@/views/administracao/Prorrogacoes.vue";
import EditarProrrogacoes from "@/views/administracao/EditarProrrogacoes.vue";

import PrazosDeVencimentoLRFCI from "@/views/administracao/PrazosDeVencimentoLRFCI.vue";
import EditarPrazoDeVencimentoLRFCI from "@/views/administracao/EditarPrazoDeVencimentoLRFCI.vue";

import ConsultarPermissoes from "@/views/cadastro-permissoes/ConsultarPermissoes.vue";

import ConsultarUsuarios from "@/views/administracao/usuarios/ConsultarUsuarios.vue";
import DetalhesUsuario from "@/views/administracao/usuarios/DetalhesUsuario.vue";
import EditarUsuario from "@/views/administracao/usuarios/EditarUsuario.vue";
import NovoUsuario from "@/views/administracao/usuarios/NovoUsuario.vue";
import UsuariosPorUG from "@/views/administracao/usuarios/UsuariosPorUG.vue";
import EditarUsuarioPorUG from "@/views/administracao/usuarios/EditarUsuarioPorUG.vue";
import TrocarSenha from "@/views/administracao/TrocarSenha.vue";
import ExibirPerfil from "@/views/administracao/usuarios/ExibirPerfil.vue";
import AprovarNovosUsuarios from "@/views/administracao/AprovarNovosUsuarios.vue";
import ConsultarAutoresEmendas from "@/views/administracao/ConsultarAutoresEmendas.vue"

import ConsultarUnidadesGestoras from '@/views/administracao/unidade-gestora/ConsultarUnidadesGestoras.vue'
import CriarUnidadeGestora from '@/views/administracao/unidade-gestora/CriarUnidadeGestora.vue'

const administracaoRotas = [
  {
    path: "/perfil",
    name: "perfil",
    component: ExibirPerfil,
  },

  {
    path: "/seguranca-administracao/prazos-vencimento",
    name: "seguranca-administracao--prazos-vencimento",
    component: PrazosDeVencimento,
  },
  {
    path: "/seguranca-administracao/prazos-vencimento/novo",
    name: "seguranca-administracao--editar-prazo-vencimento",
    component: EditarPrazoDeVencimento,
  },
  {
    path: "/seguranca-administracao/prazos-vencimento/editar/:idprazo?",
    name: "editarPrazoVencimento",
    component: EditarPrazoDeVencimento,
    props: true,
  },
  {
    path: "/seguranca-administracao/prazos-vencimento-lrf",
    name: "seguranca-administracao--prazos-vencimento-lrf",
    component: PrazosDeVencimentoLRFCI,
  },
  {
    path: "/seguranca-administracao/prazos-vencimento-lrf/novo",
    name: "seguranca-administracao--editar-prazo-vencimento-lrf",
    component: EditarPrazoDeVencimentoLRFCI,
  },
  {
    path: "/seguranca-administracao/envios-sem-movimento",
    name: "seguranca-administracao--envios-sem-movimento",
    component: EnviosSemMovimento,
  },
  {
    path: "/seguranca-administracao/envios-sem-movimento/novo",
    name: "seguranca-administracao--editar-envios-sm",
    component: EditarEnviosSM,
    props: true,
  },
  {
    path: "/seguranca-administracao/prazos-vencimento-lrf/editar/:idprazo?",
    name: "editarPrazoVencimentoLrfci",
    component: EditarPrazoDeVencimentoLRFCI,
    props: true,
  },
  {
    path: "/seguranca-administracao/prorrogacoes",
    name: "seguranca-administracao--prorrogacoes",
    component: Prorrogacoes,
  },
  {
    path: "/seguranca-administracao/prorrogacoes/novo",
    name: "seguranca-administracao--editar-prorrogacoes",
    component: EditarProrrogacoes,
    props: true,
  },
  {
    path: "/seguranca-administracao/prorrogacoes/editar/:idProrrogacao?",
    name: "editarProrrogacoes",
    component: EditarProrrogacoes,
    props: true,
  },
  {
    path: "/seguranca-administracao/permissoes-perfis",
    name: "seguranca-administracao--permissoes-perfis",
    component: ConsultarPermissoes,
    props: true,
  },

  // telas de usuários
  {
    path: "/seguranca-administracao/usuarios",
    name: "seguranca-administracao--cadastro-usuarios",
    component: ConsultarUsuarios,
    props: true,
  },
  {
    path: "/seguranca-administracao/usuarios/novo",
    name: "seguranca-administracao--criar-usuario",
    component: NovoUsuario,
  },
  {
    path: "/seguranca-administracao/usuarios/:idUsuario",
    name: "seguranca-administracao--detalhes-usuario",
    component: DetalhesUsuario,
    props: true,
  },
  {
    path: "/seguranca-administracao/usuarios/:idUsuario/editar",
    name: "seguranca-administracao--editar-usuario",
    component: EditarUsuario,
    props: true,
  },
  {
    path: "/seguranca-administracao/usuarios-ug",
    name: "seguranca-administracao--cadastro-usuarios-ug",
    component: UsuariosPorUG,
  },

  {
    path: "/seguranca-administracao/usuarios-ug/editar",
    name: "seguranca-administracao--editar-usuarios-ug",
    component: EditarUsuarioPorUG,
    props: true,
  },
  {
    path: "/seguranca-administracao/trocar-senha",
    name: "seguranca-administracao--trocar-senha",
    component: TrocarSenha,
  },
  {
    path: "/seguranca-administracao/aprovar-novos-usuarios",
    name: "seguranca-administracao--aprovar-novos-usuarios",
    component: AprovarNovosUsuarios,
  },
  {
    path: "/seguranca-administracao/autores-emendas",
    name: "seguranca-administracao--autores-emendas",
    component: ConsultarAutoresEmendas,
  },
  {
    path: "/administracao/unidades-gestoras",
    name: "administracao--unidades-gestoras",
    component: ConsultarUnidadesGestoras,
  },
  {
    path: "/administracao/criar-unidade-gestora",
    name: "administracao--criar-unidade-gestora",
    component: CriarUnidadeGestora,
  },
  {
    path: "/administracao/editar-unidade-gestora/:idUg",
    name: "administracao--editar-unidade-gestora",
    component: CriarUnidadeGestora,
    props: true,
  },
  {
    path: "/administracao/ver-unidade-gestora/:idUg/:isDetail",
    name: "administracao--ver-unidade-gestora",
    component: CriarUnidadeGestora,
    props: true,
  },
];

export { administracaoRotas };
